import { useEffect, useState, type RefObject } from 'react';

/**
 * True once `ref`'s element has come within 200 px of the viewport (and for good after: one
 * sighting disconnects). Without IntersectionObserver everything counts as near. `active` false
 * observes nothing (a picture that never snapshots has no use for it).
 */
export function useNearView(ref: RefObject<Element>, active = true): boolean {
  const [near, setNear] = useState(typeof IntersectionObserver === 'undefined');
  useEffect(() => {
    if (!active || near || !ref.current) return;
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { setNear(true); io.disconnect(); } }, { rootMargin: '200px' }); // raw-ok: IntersectionObserver margin (JS, not CSS)
    io.observe(ref.current);
    return () => io.disconnect();
  }, [active, near, ref]);
  return near;
}
